import { EventEmitter, Injectable, Output } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SideMenuService {
  @Output() _toggleSidebar: EventEmitter<any> = new EventEmitter<any>();

  toggleSidebar() {
    this._toggleSidebar.emit();
  }
}
